<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-维修记录-修改
    -->
    <el-dialog
    title="查看评价"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="60%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">查看评价</div>

      <el-form-item label="评价用户" prop="nickName">
        <img :src="form.avatarUrl || '/static/images/default_avatar.png'" class="radius" width="30" height="30" />
        <p class="lh18 ww100 text-ellipsis">{{form.nickName}}</p>
      </el-form-item>
      <el-form-item label="评价星级" prop="service_rating">
        <el-input v-model="form.service_rating" placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="评价时间" prop="create_time">
        <el-input v-model="form.create_time" placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <!-- 评价内容 -->
      <el-form-item label="评价内容" prop="comment">
        <el-input
          type="textarea"
          :rows="3"
          v-model="form.comment"
          placeholder=""
          class="max-w460">
        </el-input>
      </el-form-item>      
    </el-form>
    
  </div>
</el-dialog>
</template>

<script>
import Maintenance_recordApi from '@/api/maintenance_record.js';
import draggable from "vuedraggable";

export default {
  components: {
     draggable
  },
  data() {
    return {
      /*是否上传图片*/
      isupload: false,
      isImg: false,  
      /*form表单数据*/
      form: {
        avatarUrl:'',
        nickName:'',
        comment: '',
        service_rating: 0,
        create_time: ''
      },
      loading: false,
      /*验证规则*/
      rules: {},
      dialogVisible: false,
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add","maintenance_record_id"],
  methods: {

    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc() {
      this.dialogFormVisible("error");
    },
    getDetail() {
      let self = this;
      Maintenance_recordApi.commentDetail({maintenance_record_id: self.maintenance_record_id}, true).then(res => {
          self.form = res.data;
          self.loading = false;
          
        })
        .catch(error => {
          self.loading = false;
        });
    },
  }
};
</script>

<style>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: 'red';
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.max-w460 {
  max-width: 460px;
}

.tip-text {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
}

.el-form-item {
  margin-bottom: 15px;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/maintenance_record/index/part/comment.vue